import Alpine from "alpinejs"

Alpine.data("accordion", () => ({
    toggle(el, force = false) {
        Array.from(this.$root.children).forEach((child) => {
            if (child !== el) {
                child.open = false
            }
        })
        force && (el.open = true)
    },
    anchorMatchHandler(element, originalEvent) {
        if (originalEvent.type === "DOMContentLoaded") {
            element.scrollIntoView({ behavior: "smooth", block: "start" })
        }
        this.toggle(element, true)
    },
}))
